import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';
// ngrx store
import { Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
// services
import { FlightDetailsService } from './flight-details.service';
// globals
import { API_PATH, SUBSCRIPTION_KEY, GET_RETURN_SESSION, GET_LEAD_IN_SESSION, GET_TOKEN_DATA, VALIDATE_SMS_CODE } from '../../shared/globals';
// enums
import { SupportedAirports } from '../enum/supported-airports.enum';
import moment from 'moment';

const SESSION_DATA = makeStateKey ('session_data');
const TOKEN_DATA = makeStateKey ('token_data');
const INDIVIDUAL_DATA = makeStateKey('individual_data');
const IS_CUSTOMER_SUPPORT = makeStateKey ('is_customer_support');

let sessionId = null;
let sessionData = null;
let tokenData = null;
let individualData = null;
let promoParam = null;
let productTierParam = null;
let isCustomerSupport = null;

interface TokenRequest  {token: string; }

@Injectable({
  providedIn: 'root',
})
export class SessionService {

  private _sessionParamsSubscription: Subscription;
  private _sessionId = null;
  private _urlToken = null;
  private _urlEmail = null;

  public sessionDataReturned$: BehaviorSubject<any> = new BehaviorSubject(null);
  public tokenDataReturned$: BehaviorSubject<any> = new BehaviorSubject(null);
  public individualDataReturned$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private _http: HttpClient,
    private _serverState: TransferState,
    private _flightsService: FlightDetailsService,
    private _activatedRoute: ActivatedRoute
  ) {}

  checkQuerySession() {

    sessionData = this._serverState.get(SESSION_DATA, null as any);
    tokenData = this._serverState.get(TOKEN_DATA, null as any);
    individualData = this._serverState.get(INDIVIDUAL_DATA, null as any);
    isCustomerSupport = this._serverState.get(IS_CUSTOMER_SUPPORT, null as any);

    console.log('session data', sessionData, 'token data', tokenData, 'indiviual data', individualData)

    if (sessionData === null || tokenData === null || individualData === null || isCustomerSupport === null) {

      // subscribe to router query string
      this._sessionParamsSubscription = this._activatedRoute.queryParams
        .subscribe((params: any) => {
          console.log('params', params);

          // if no params return null
          if (Object.keys(params).length === 0) { return null; }

          // if promo has been sent in query string
          // set in var
          if (typeof params.p !== 'undefined') {
            promoParam = params.p;
          } else {
            promoParam = null;
          }
          // if product tier has been sent in query string
          // set in var
          if (typeof params.pt !== 'undefined') {
            productTierParam = params.pt;
          } else {
            productTierParam = null;
          }

          // if CS MOTO payment flag has been sent in query string
          // set in var
          if (typeof params['airportr-cs-moto'] !== 'undefined') {
            const val = params['airportr-cs-moto'] === 'true';
            this._serverState.set(IS_CUSTOMER_SUPPORT, val as any);
            isCustomerSupport = val;
          }

          // store session or returnSession
          if (typeof params.session !== 'undefined') {
            sessionId = params.session;
            this._sessionId = params.session;
            console.log('store session',this._sessionId);
            this.callSessionApiPromise(this._sessionId, false).then((sessionResponse: any) => {
              console.log('sessionResponse', sessionResponse);
              this.updateSessionResponse(sessionResponse);
              this.sessionDataReturned$.next(true);
              this._sessionParamsSubscription.unsubscribe();
            }).catch(err => {
              console.log('error',err);
              this.sessionDataReturned$.next(false);
              this._sessionParamsSubscription.unsubscribe();
            });
          } else if (typeof params.returnSession !== 'undefined') {
            this._sessionId = params.returnSession;
            this.callSessionApiPromise(this._sessionId, true).then((sessionResponse: any) => {
              console.log('--2', sessionResponse);
              this.updateSessionResponse(sessionResponse);
              this.sessionDataReturned$.next(true);
              this._sessionParamsSubscription.unsubscribe();
            }).catch(err => {
              this.sessionDataReturned$.next(false);
              this._sessionParamsSubscription.unsubscribe();
            });
          } else {
            // no session
            // this.sessionDataReturned$.next(false);
            this._sessionParamsSubscription.unsubscribe();
          }

          // handle verify page token data with otp
          if (
            typeof params.token !== "undefined" &&
            typeof params.email !== "undefined"
          ) {
            this._urlToken = params.token;
            this._urlEmail = params.email;
            this.callOtpTokenApiPromise(params.token, params.email)
              .then((tokenResponse: any) => {
                this.updateTokenResponse(tokenResponse);
                this.tokenDataReturned$.next(true);
              })
              .catch((err) => {
                // send error back to client......
                this.updateTokenError(err);
                this.tokenDataReturned$.next(true);
              });
          }

          // handle verify page token data
          // used for magic link user redirect
          if (typeof params.token !== 'undefined') {

            this._urlToken = params.token;
            this.callTokenApiPromise(params.token).then((tokenResponse: any) => {

              this.updateTokenResponse(tokenResponse);
              this.tokenDataReturned$.next(true);
            }).catch(err => {
              // send error back to client......
              this.updateTokenError(err);
              this.tokenDataReturned$.next(true);
            });
          }

          // handle individual flight items
          // used to call flightStats from email link
          console.log('params upper check', params);
          if (typeof params.departureAirportCode !== 'undefined' && typeof params.arrivalAirportCode !== 'undefined' && typeof params.flightDateTime !== 'undefined' && typeof params.airlineCode !== 'undefined' && typeof  params.airlineName !== 'undefined') {

            console.log('params upper', params);
            const hasError = this.checkInidividualParams(params);
            if (!hasError) {
              try {
                const flightRequestObj: any = {
                  departureAirport: params.departureAirportCode,
                  arrivalAirport: params.arrivalAirportCode,
                  fromAirport: params.departureAirportName,
                  toAirport: params.arrivalAirportName,
                  airline: params.airlineCode,
                  airlineName: params.airlineName,
                  flightNumber: params.flightnumber ? params.flightnumber : null,
                  departDate: params.flightDateTime,
                  fromCity: null,
                  toCity: null,
                  bagCount: 1,
                  bagsClassification: [
                    {
                      "type": 1,
                      "count": 1
                    },
                    {
                      "type": 2,
                      "count": 0
                    },
                    {
                      "type": 3,
                      "count": 0
                    }
                  ],
                };
                this.updateIndividualFlightItems(flightRequestObj);
                this.individualDataReturned$.next(true);
              } catch (err) {
                this.individualDataReturned$.next(false);
              }
            } else {
              this.individualDataReturned$.next(false);
            }
          }

        },
        err => console.log(err));
    } else {
      return {token: tokenData, flight: sessionData, individualData: individualData, isCustomerSupport: isCustomerSupport};
    }
  }

  private updateIndividualFlightItems(queryData: any) {
    queryData.hasSession = true;
    queryData.promoParam = promoParam;
    queryData.productTierParam = productTierParam;
    individualData = { hasError: false, data: queryData };
    this._serverState.set(INDIVIDUAL_DATA, individualData as any);
  }

  private updateSessionResponse(sessionResponse: any) {
    const qData = sessionResponse;
    qData.hasSession = true;
    qData.sessionID = this._sessionId;
    qData.promoParam = promoParam;
    qData.productTierParam = productTierParam;
    sessionData = { hasError: false, data: qData };
    this._serverState.set(SESSION_DATA, sessionData as any);
  }

  private updateTokenResponse(tokenResponse: any) {
    const qData = tokenResponse;
    qData.urlToken = this._urlToken;
    qData.urlEmail = this._urlEmail;
    tokenData = { hasError: false, data: qData };
    this._serverState.set(TOKEN_DATA, tokenData as any);
  }

  private updateTokenError(tokenError: any) {
    tokenData = { hasError: true, data: tokenError, email: this._urlEmail};
    this._serverState.set(TOKEN_DATA, tokenData as any);
  }

  private checkInidividualParams(p: {departureAirportCode: string; arrivalAirportCode: string; flightDateTime: string; airlineCode: string; airlineName: string; }) {

    const errors = {
      departureAirport: false,
      arrivalAirport: false,
      date: false
    };

    let journeyDirection = null;

    if (p.departureAirportCode.toLocaleUpperCase() in SupportedAirports) {
      errors.departureAirport = false;
      journeyDirection = 1;
    } else {
      errors.departureAirport = true;
    }

    if (p.arrivalAirportCode.toLocaleUpperCase() in SupportedAirports) {
      errors.arrivalAirport = false;
      journeyDirection = 2;
    } else {
      errors.arrivalAirport = true;
    }

    const depart = moment(p.flightDateTime);
    if (depart.isBefore(moment()) && journeyDirection === 1) {
      // session has date in the past...
      errors.date = true;
    }

    const dataHasError = (errors.departureAirport && errors.arrivalAirport) || errors.date;
    return dataHasError;

  }

  callSessionApiPromise(sessionID: string, isReturnSession: boolean) {
    let path = '';
    let qPath = '';
    if (isReturnSession) {
      path = GET_RETURN_SESSION;
      qPath = '?returnSessionId=';
    } else {
      path = GET_LEAD_IN_SESSION;
      qPath = '?sessionId=';
    }

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const promise = new Promise((resolve, reject) => {
      this._http
        .get(API_PATH + path + qPath + sessionID, {headers:headers})
        .toPromise()
        .then((res:any) => { resolve(res); })
        .catch(err => { reject(err); });
    });
    return promise;

  }

  callOtpTokenApiPromise(code: string, emailAddress: string, referrer: string = 'mmb-login') {

    const promise = new Promise((resolve, reject) => {
      const request = {
        token: code,
        emailAddress: emailAddress,
        referrer: referrer,
      };
      console.log('OTP REQUEST', request);
      const storeCookie = true;
      const isGuest = false;
      // const headers = new HttpHeaders();
      // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
      const headers = new HttpHeaders().set(
        "Ocp-Apim-Subscription-Key",
        SUBSCRIPTION_KEY
      );

      this._http
        .post(API_PATH + VALIDATE_SMS_CODE, request, { headers: headers })
        .toPromise()
        .then((res: any) => {
          console.log('OTP', res);
          resolve(res);
          // const returnedData = res;
          // const token = returnedData.token;
          // const parsedToken = this.parseReturnedData(token);

          // this.loginAccessToken(parsedToken.access_token, storeCookie, isGuest);
        })
        .catch((err) => {
          console.log('OTP ERROR', JSON.stringify(err.error.validationErrorMessages));
          this.updateTokenError(err);
          return;
        });

    });
    return promise;
  }

  callTokenApiPromise(tokenID: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const request: TokenRequest = { token: tokenID };
    const promise = new Promise((resolve, reject) => {
      this._http
      .post(API_PATH + GET_TOKEN_DATA, request, {headers:headers})
        .toPromise()
        .then((res:any) => { resolve(res); })
        .catch(err => { this.updateTokenError(err); });
    });
    return promise;

  }

  getQuerySessionId() {
    // return session id
    return sessionId;
  }

  getQuerySessionData() {
    // return session data
    return sessionData;
  }

  getQueryTokenData() {
    // return session data
    return tokenData;
  }

  getQueryIndividualData() {
    // return session data
    return individualData;
  }

  getQueryIsCustomerSupport() {
    return isCustomerSupport;
  }

  resetSessionData() {
    sessionId = null;
    sessionData = null;
    tokenData = null;
    promoParam = null;
    productTierParam = null;
    isCustomerSupport = null;
  }

  parseReturnedData(value: any) {
    const parsed = JSON.parse(value);
    return parsed;
  }

}
